import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Output, Input, NgModule } from '@angular/core';
import { DomHandler } from 'primeng/dom';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class MaximizeDialogLibraryService {
    constructor() { }
}
MaximizeDialogLibraryService.ɵfac = function MaximizeDialogLibraryService_Factory(t) { return new (t || MaximizeDialogLibraryService)(); };
MaximizeDialogLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: MaximizeDialogLibraryService, factory: MaximizeDialogLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MaximizeDialogLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class MaximizeDialogLibraryComponent {
    constructor() {
        this.maximized = true;
        this.onMaximize = new EventEmitter();
        this.keyToBeMatched = 'layoutCode';
        this.maximizedDialogClass = 'p-dialog-maximized';
        this.maximizedIconClass = 'icon-window-maximize';
        this.minimizedIconClass = 'icon-window-minimize';
    }
    ngOnInit() {
        // removing toggle functionality and keeping the dialog full screen always
        // if(this.configData && this.configData[this.keyToBeMatched]){
        //     this.maximized = this.getPersistanceByLayoutCode(this.configData[this.keyToBeMatched]);
        //     this.maximize();
        // }
        // if(sessionStorage.getItem('isSimplify') && sessionStorage.getItem('isSimplify')=='CWF'){
        //   this.maximized = true;
        //   this.maximize();
        // }
        this.maximize();
    }
    getPersistanceByLayoutCode(code) {
        let persistedModalsArr = this.getPersistedModals();
        let isPersistedModal = false;
        if (persistedModalsArr.length) {
            const index = persistedModalsArr.findIndex((value) => value.layoutCode === code && value.maximized);
            isPersistedModal = index > -1 ? true : false;
        }
        return isPersistedModal;
    }
    getPersistedModals() {
        const persistedModals = localStorage.getItem('maximizedModals');
        if (persistedModals) {
            return JSON.parse(persistedModals);
        }
        return [];
    }
    toggleMaximize() {
        this.maximized = !this.maximized;
        this.maximize();
        this.updatePersistance();
        this.onMaximize.emit({ maximized: this.maximized });
    }
    maximize() {
        let dialogEl = DomHandler.findSingle(document.body, 'p-dynamicdialog .p-dialog'); // for visa steps
        dialogEl || (dialogEl = DomHandler.findSingle(document.body, '.p-dialog')); //for RFE
        if (!dialogEl)
            return;
        if (this.maximized) {
            DomHandler.addClass(dialogEl, this.maximizedDialogClass);
        }
        else {
            DomHandler.removeClass(dialogEl, this.maximizedDialogClass);
        }
    }
    updatePersistance() {
        let persistedModalsArr = this.getPersistedModals();
        if (persistedModalsArr.length && this.configData[this.keyToBeMatched]) {
            const index = persistedModalsArr.findIndex((value) => value.layoutCode === this.configData[this.keyToBeMatched]);
            if (index > -1) {
                persistedModalsArr[index]['maximized'] = this.maximized;
            }
            else {
                persistedModalsArr.push({ maximized: this.maximized, 'layoutCode': this.configData[this.keyToBeMatched] });
            }
        }
        else if (this.configData[this.keyToBeMatched]) {
            persistedModalsArr = [{ maximized: this.maximized, 'layoutCode': this.configData[this.keyToBeMatched] }];
        }
        localStorage.setItem('maximizedModals', JSON.stringify(persistedModalsArr));
    }
}
MaximizeDialogLibraryComponent.ɵfac = function MaximizeDialogLibraryComponent_Factory(t) { return new (t || MaximizeDialogLibraryComponent)(); };
MaximizeDialogLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MaximizeDialogLibraryComponent, selectors: [["lib-maximize-dialog-library"]], inputs: { configData: "configData" }, outputs: { onMaximize: "onMaximize" }, decls: 2, vars: 1, consts: [[1, "d-none", "p-dialog-header-maximize-icon", "pr-1", 3, "click"], [3, "ngClass"]], template: function MaximizeDialogLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "span", 0);
        i0.ɵɵlistener("click", function MaximizeDialogLibraryComponent_Template_span_click_0_listener() { return ctx.toggleMaximize(); });
        i0.ɵɵelement(1, "i", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.maximized ? ctx.minimizedIconClass : ctx.maximizedIconClass);
    } }, directives: [i1.NgClass], styles: [".p-dialog-header-maximize-icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{\n      font-size: 1.8rem;\n      cursor: pointer;\n    }\n    .p-dialog-header-maximize-icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{ \n      display: inline-block;\n    }\n    .icon-window-maximize[_ngcontent-%COMP%]{\n      background-image: url(../../../../assets/images/modal-expand.svg);\n      width: 26px;\n      height: 26px;\n    }\n    .icon-window-minimize[_ngcontent-%COMP%]{\n      background-image: url(../../../../assets/images/modal-collapse.svg);\n      width: 25px;\n      height: 25px;\n    }"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MaximizeDialogLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-maximize-dialog-library',
                template: `
    <span (click)="toggleMaximize()" class="d-none p-dialog-header-maximize-icon pr-1"><i [ngClass]="maximized ? minimizedIconClass : maximizedIconClass"></i></span>
  `,
                styles: [`
    .p-dialog-header-maximize-icon i{
      font-size: 1.8rem;
      cursor: pointer;
    }
    .p-dialog-header-maximize-icon i{ 
      display: inline-block;
    }
    .icon-window-maximize{
      background-image: url(../../../../assets/images/modal-expand.svg);
      width: 26px;
      height: 26px;
    }
    .icon-window-minimize{
      background-image: url(../../../../assets/images/modal-collapse.svg);
      width: 25px;
      height: 25px;
    }
  `]
            }]
    }], function () { return []; }, { onMaximize: [{
            type: Output
        }], configData: [{
            type: Input
        }] }); })();

class MaximizeDialogLibraryModule {
}
MaximizeDialogLibraryModule.ɵfac = function MaximizeDialogLibraryModule_Factory(t) { return new (t || MaximizeDialogLibraryModule)(); };
MaximizeDialogLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: MaximizeDialogLibraryModule });
MaximizeDialogLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MaximizeDialogLibraryModule, { declarations: [MaximizeDialogLibraryComponent], imports: [CommonModule], exports: [MaximizeDialogLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MaximizeDialogLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [MaximizeDialogLibraryComponent],
                imports: [
                    CommonModule
                ],
                exports: [MaximizeDialogLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of maximize-dialog-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MaximizeDialogLibraryComponent, MaximizeDialogLibraryModule, MaximizeDialogLibraryService };
//# sourceMappingURL=maximize-dialog-library.js.map
